import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Dialog, BasicDialogBody } from '../../legacy-design-system/modal'
import { Link } from '@contrast-security-inc/design-system-typography'

const salesEmail = 'sales@contrastsecurity.com'

interface Props {
  readonly isOpen: boolean
  readonly closeDialog: () => void
}

export function NoLicensesModal({ isOpen, closeDialog }: Props) {
  return (
    <Dialog
      isOpen={isOpen}
      onCancel={closeDialog}
      renderTitle={() => (
        <FormattedMessage
          id="action_application_upgradeLicense"
          defaultMessage="Upgrade License"
        />
      )}
      size="small"
    >
      <BasicDialogBody
        body={
          <FormattedMessage
            id="variable_upgradeLicenseApplication_licenseUnavailableToApply_Component"
            values={{
              link: (
                <Link href={`mailto:${salesEmail}`} isExternal>
                  {salesEmail}
                </Link>
              )
            }}
          />
        }
        confirmButtonText={<FormattedMessage id="action_ok" />}
        cancelButtonText={<FormattedMessage id="action_close" />}
        onCancel={closeDialog}
        onConfirm={closeDialog}
      />
    </Dialog>
  )
}
